// DO NOT UPDATE MANUALLY: Generated from script during build time
export var VERSION = '29.3.5';
